import { DroneIcon } from '@american-autonomy/rantizo-ui';

import ItemCard from 'components/cards/ItemCard';
import ItemCardText from 'components/text/ItemCardText';
import ItemCardTitle from 'components/text/ItemCardTitle';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const BaseNoEquipmentCard: FunctionComponent<Props> = ({
    className = '',
    message,
    testId = TEST_ID,
    title
}) => (
    <ItemCard className={`${styles.baseNoEquipmentCard} ${className}`} testId={testId}>
        <DroneIcon className={styles.droneIcon} />

        <ItemCardTitle text={title} />

        <ItemCardText text={message} />
    </ItemCard>
);

export default BaseNoEquipmentCard;
